import React, { forwardRef } from 'react';
import { Modal, Box, useTheme } from '@mui/material';

interface DSContractModalProps
  extends Omit<React.ComponentProps<typeof Modal>, 'children'> {
  children: React.ReactNode;
}

const DSContractModal = forwardRef<HTMLDivElement, DSContractModalProps>(
  (props, ref) => {
    const { children, ...modalProps } = props;
    const { spacing } = useTheme();

    return (
      <Modal {...modalProps}>
        <Box
          ref={ref}
          sx={{
            outline: null,
            position: 'absolute',
            width: '90%',
            height: '90%',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            p: spacing(2),
            display: 'flex',
            flexDirection: 'column',
            gap: spacing(2),
          }}
        >
          {children}
        </Box>
      </Modal>
    );
  },
);

export default DSContractModal;
